module.exports = __webpack_public_path__ + "static/media/13-RPEX 6.d3dee94e.jpg";